import { Repositories  } from ".."

export interface Service {
	promptVariationsForPrompt: (prompt: string, promptVariationsCount: number) => Promise<string[]>
}

export const factory = (repository: Repositories.PromptVariations.Repository): Service => ({
	promptVariationsForPrompt: (prompt: string, promptVariationsCount: number): Promise<string[]> =>
		repository.promptVariationsForPrompt(prompt, promptVariationsCount)
})